import tw, { styled } from "twin.macro"

const CourseTermsWrapper = styled.div`
  ${tw`p-2 py-4 bg-gray-100`}
`

export default CourseTermsWrapper
